module.exports = __webpack_public_path__ + "img/redPark.66e58e0d.svg";